import { ChakraV3, FloatingPopover } from '@piccolohealth/ui';
import React from 'react';
import { FaRegClock } from 'react-icons/fa';
import { ParticipantTimelineContents } from './ParticipantTimelineContents';

interface Props {
  participantId: string;
}

export const ParticipantTimelineControl = (props: Props) => {
  const { participantId } = props;
  const disclosure = ChakraV3.useDisclosure();

  return (
    <FloatingPopover
      isRoot={true}
      open={disclosure.open}
      setOpen={(open) => (open ? disclosure.onOpen() : disclosure.onClose())}
      render={() => <ParticipantTimelineContents participantId={participantId} />}
    >
      <ChakraV3.Button onClick={disclosure.onToggle} variant='ghost' size='sm' lineHeight={1}>
        <FaRegClock />
        History
      </ChakraV3.Button>
    </FloatingPopover>
  );
};
